import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select ,DatePicker,Modal  } from 'antd';
import ModalImage from "react-modal-image";

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import search from '../../assets/images/icon/search.png';
import close from '../../assets/images/icon/delete.png';


const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}


function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function onChange_(date, dateString) {
  console.log(date, dateString);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			title: '',
			tabs: '1',
			user_id: '',
			child_id: 0,
			program: '',
			program_name: '',
			from_date: '',
			to_date: '',
			activity: '',
			name: '',
			date: '',
			details: '',
			school_list: [],
			program_list: [],
			staff_list: [],
			album: [],
			single_history: [],
			daily_report: [1],
			visible: false
		}
		this.change_program = this.change_program.bind(this);
		this.change_activity = this.change_activity.bind(this);
		this.search = this.search.bind(this);
		this.close = this.close.bind(this);
		this.onChangefrom_ = this.onChangefrom_.bind(this);
		this.onChangeto_ = this.onChangeto_.bind(this);
	}
	
	showDrawer(id,case_type,title,student_id){
		
			var user_id = student_id;
			var id = id;
			var case_type = case_type;
			var app = {user_id : user_id,case:case_type,id:id,}
			getData('erp/single_history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							single_history: result['data'],
						});
					}else{
						this.setState({
							single_history: [],
							
						});
					}
				}
			});
		
		
		this.setState({
		  mobile_child: true,
		  title: title,
		});
	};
	 
	onClose = () => {
		this.setState({
		  mobile_child: false,
		});
	  }; 
	
	showDrawerClass = () => {
		this.setState({
		  mobile_class: true,
		});
	  };
	 
	onCloseClass = () => {
		this.setState({
		  mobile_class: false,
		});
	  }; 	
	
	
	showModal(id,case_type,title,student_id){
		
		
			var user_id = student_id;
			var id = id;
			var case_type = case_type;
			var app = {user_id : user_id,case:case_type,id:id,}
			getData('erp/single_history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							single_history: result['data'],
						});
					}else{
						this.setState({
							single_history: [],
							
						});
					}
				}
			});
		
		
		this.setState({
		  visible: true,
		  title: title,
		});
	};
  
	handleOk = e => {
		console.log(e);
		this.setState({
		  visible: false,
		  mobile_child: false,
		});
	  };

	handleCancel = e => {
		console.log(e);
		this.setState({
		  visible: false,
		});
	  };
	
	onChangefrom_(time, timeString) {
	  this.setState({
		  from_date: timeString,
		});
	}
	
	onChangeto_(time, timeString) {
	  this.setState({
		  to_date: timeString,
		});
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] ,school_id : storedArray['data'][0]['school_id'] });
		this.checkData()
		}
	}
	
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var child_id = this.state.child_id;
			var program = this.state.program;
			var activity = this.state.activity;
			var from_date = this.state.from_date;
			var to_date = this.state.to_date;
			var school_id = school_id;
			var app = {user_id : user_id,child_id:child_id,program:program,activity:activity,to_date:to_date,from_date:from_date,school_id:school_id}
			getData('erp/history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							
						});
						
						if(result['data'].length>0){
							document.getElementById('error').innerHTML = '';
							document.getElementById('error_1').innerHTML = '';
						}else{
							document.getElementById('error').innerHTML = 'No Data Found ';
							document.getElementById('error_1').innerHTML = 'No Data Found ';
						}
						
					}else{
						this.setState({
							school_list: [],
							
						});
						
						document.getElementById('error').innerHTML = 'No Data Found ';
						document.getElementById('error_1').innerHTML = 'No Data Found ';
					}
				}
			});
			var app_ = {user_id : user_id,school_id:school_id}
			getData('erp/program_list',app_).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
						});
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});
			getData('erp/view_staff',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							staff_list: result['data'],
							
						});
					}else{
						this.setState({
							staff_list: [],
							
						});
					}
				}
			});
	}
  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  openQuantity(e){
	this.setState({ tabs: e });
	} 

	change_program(event){
         this.setState({program: event});
		 
     }
	 
	change_activity(event){
         this.setState({activity: event});
		 
     }

	search(){
		this.setState({
							school_list: [],
							mobile_class: false,
							
						});
		var active = 1;
		var user_id = this.state.user_id;
			var child_id = this.state.child_id;
			var program = this.state.program;
			var activity = this.state.activity;
			var from_date = this.state.from_date;
			var to_date = this.state.to_date;
			var school_id = this.state.school_id;
			var app = {user_id : user_id,child_id:child_id,program:program,activity:activity,to_date:to_date,from_date:from_date,school_id:school_id}
			if(from_date != ''){
				if(to_date == ''){
					message.config({ top: 150});
					message.error('Please Select To Date',2);
					var active = 0;
				}else{
					var active = 1;
				}
			}
			if(to_date != ''){
				if(from_date == ''){
					message.config({ top: 150});
					message.error('Please Select From Date',2);
					var active = 0;
				}else{
					var active = 1;
				}
			}
			if(active == 1){
			getData('erp/history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							daily_report: result['data']['0']['daily_report'],
						});
						if(result['data'].length>0){
							document.getElementById('error').innerHTML = '';
							document.getElementById('error_1').innerHTML = '';
						}else{
							document.getElementById('error').innerHTML = 'No Data Found ';
							document.getElementById('error_1').innerHTML = 'No Data Found ';
						}
						
					}else{
						this.setState({
							school_list: [],
						});
						
						document.getElementById('error').innerHTML = 'No Data Found ';
						document.getElementById('error_1').innerHTML = 'No Data Found ';
					}
				}
			});
			}
	}
	
	close(){
		window.location.href = '/history/index';
		this.setState({child_id: '',program:'',activity:'',from_date:'',to_date:''});
		var user_id = this.state.user_id;
			var child_id = '';
			var program = '';
			var activity = '';
			var from_date = '';
			var to_date = '';
			var app = {user_id : user_id,child_id:child_id,program:program,activity:activity,to_date:to_date,from_date:from_date}
			getData('erp/history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
	}
		

	render()

	{
	const lenght = this.state.school_list.length;
	const lenght_1 = this.state.daily_report.length;
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                    
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">History</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           
                           <li class="breadcrumb-item active">History
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
           
            
			
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-10 card-content mh-500 iq-card">
			  
                  <section class="invoice-list-wrapper section food ">
				  
				<div class="desktop-view">	
					<div class="children bg-blue communication iq-card2 flow-root">
                     		
								
								<div class="col m12 s12 view-Profile no-padd ">
										<div class="col m2 s6 mt-5">
											<label>From Date</label>
									        <DatePicker onChange={this.onChangefrom_} />
										</div>
										<div class="col m2 s6 mt-5">
											<label>To Date</label>
									        <DatePicker onChange={this.onChangeto_} />
										</div>
										<div class="col m2 s6 mt-5">
											<label>Select Program</label>
											<Select name="program" value={this.state.program}  onChange={this.change_program}>
												<Select.Option value="">Select</Select.Option>
												{this.state.program_list.map((list) => ( 
													<Select.Option value={list.id}>{list.name}</Select.Option>
												))}
											</Select>
										</div>
										<div class="col m2 s6 mt-5 mb-10">
											<label >Activity				</label>
											<Select name="activity" value={this.state.activity}  onChange={this.change_activity}>
												
												<Select.Option value="dairy">Diary</Select.Option>
												<Select.Option value="food">Food</Select.Option>
												<Select.Option value="health">Health</Select.Option>
												<Select.Option value="observation">Observation</Select.Option>
												<Select.Option value="play_learn">Play & Learn</Select.Option>
												<Select.Option value="potty">Potty</Select.Option>
												<Select.Option value="star">Star</Select.Option>
												<Select.Option value="sleep">Sleep</Select.Option>
											</Select>
										</div>
										<div class="col m2 s6 mt-5">
											<label>Staff</label>
											<Select>
												{this.state.staff_list.map((list) => ( 
													<Select.Option value={list.id}>{list.first_name}</Select.Option>
												))}
											</Select>
										</div>
										
										<div class="col m2 s6 mt-20 mb-20 center">
											<img src={search} class="history-img mt-5 cursor"  onClick={this.search} />
											<img src={close} class="history-img mt-5 cursor"  onClick={this.close} />
										</div>
										
								</div>
								
								 <div class="col m12 s12 no-padd">
								 
								 <p id="error" class="center mt-20">Please Wait While Loading !!</p>
								 
								 {this.state.school_list.map((list) => (
								 
									
									
									<div class="col s12 m12  add-notice no-padd">
										<div class="row">
										{list.daily_report.map((row) => (
										<div>
										
										<div class="col m12 s12 bb center image hidden-xs">
											<div class="dailry-report mb-20 mt-20"><b class="bg-color-1">{row.added_date}</b></div>
										</div>
										<div class="col m12 s12 center image bg-off hidden-md">
											<div class="dailry-report  pt-20 pb-20 "><b class="bg-color-1">{row.added_date}</b></div>
										</div>
										{row.list.map((sleep) => (
										<div>		
										<div class="col m12 s12 bb pb-20 mt-20 mt-20 no-padd">
											<div class="col m1 s2 title pt-10">
												<img src={sleep.image} class="atd-img" />
											</div>
											<div class="col m10 s10 title">
												<div class="col m12 s12 cursor" onClick={this.showModal.bind(this,sleep.id,sleep.case,sleep.title,sleep.student_id)}>
												{(()=>{																if (sleep.profile_pic != '') {
															return (
																<img src={sleep.profile_pic} class="history-img" /> 
															)
													}else{
															return (
																<img src={person} class="history-img" /> 
															)
													}
												})()}
													
													<b>{sleep.first_name} {sleep.last_name}</b>
												</div>
												<div class="col m12 s12 pb-20">
													<div class="col m8 s9 no-padd">
														<div class="notes-desc "><b>{sleep.title}</b> </div>
														<div class="notes-desc ">{sleep.details}</div>
													</div>	
													<div class="col m4 s3 no-padd">
													<div class="notes-desc right">{sleep.added_time}</div>
													</div>
												</div>	
											</div>
											
										</div>	
										
										
										
										
										
										</div>
										))}
										<Modal
											  title={this.state.title}
											  visible={this.state.visible}
											  onOk={this.handleOk}
											  className="history"
											>	
											<>
											{this.state.single_history.map((list)=>(
											<>
											  <p>Program Name : {list.program_name}</p>
											  <p>
												{(()=>{																if (list.profile_pic != '') {
															return (
																<img src={list.profile_pic} class="history-img" /> 
															)
													}else{
															return (
																<img src={person} class="history-img" /> 
															)
													}
												})()}
											  <b>{list.first_name} {list.last_name} </b> <span class="right mt-10 modal-time">{list.date}</span></p>
											  
											    {(() => {
												if(list.case == 'sleep') {
												return (
														<div>
														  <p>Start Time : {list.start_time}</p>
														  <p>End Time : {list.end_time}</p>
														</div>  
														)
												}
												})()}
												
												{(() => {
												if(list.case == 'play_learn') {
												return (
													<div>
													  <p>Activity Type : {list.activity_type}</p>
													  <p>Start Time : {list.start_time}</p>
													  <p>End Time : {list.end_time}</p>
													  <p>Item Name : {list.item_name}</p>
													 </div> 
													  )
												}
												})()}

												
												
												{(() => {
												if(list.case == 'potty') {
												return (
														<div>
														  <p>Type : {list.type}</p>
														  <p>Sub Type : {list.sub_type}</p>
														</div>
														)
												}
												})()}
											  
												
												
												{(() => {
												if(list.case == 'health') {
												return (
														<div>
														  <p>Health Type : {list.health_type}</p>
														  <p>Weight : {list.weight}</p>
														  <p>Height : {list.height}</p>
														  <p>Curcumtance : {list.head}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'observation' ) {
												return (
														<div>
														  <p>Observation Type : {list.observation_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'dairy' ) {
												return (
														<div>
														  <p>Communication Type : {list.communication_type}</p>
														  <p>Like : {list.like_type}</p>
														  <p>Comment : {list.comment_type}</p>
														  <p>Notification : {list.notification_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'food' ) {
												return (
														<div>
														  <p>Meal Type : {list.meal_type}</p>
														  <p>Quantity : {list.quantity}</p>
														  <p>Item Name : {list.food_item_name}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'star' ) {
												return (
														<div>
														  <p>Star Type : {list.star_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'gallery' ) {
												return (
															<div class="history-modal-img">
															  <p>Album Name : {list.album_name}</p>
															  {list.album.map((img) => (
																<>
																	{(() => {
																		if (img.type == 'image' ) {
																		return (
																				<ModalImage  small={img.url} large={img.url} hideDownload="true" /> 
																				)
																		}else if(img.type == 'video'){
																			return (
																				<video style={{'margin-top' : '10px'}} width="320" height="240" controls>
																				  <source src={img.url} type="video/mp4" />
																				  <source src={img.url} type="video/ogg" />
																				</video> 
																				  )
																		}
																	})()}
																</>	
																))}
															</div>  
														  )
												}
												})()}
														 
														 
												
											  <p>Details : {list.details}</p>
											  
											  {(() => {
												if (list.attach == '1' ) {
												return (
														<div>
															<span>Attachment :</span>
															<div class="attachment">
															   {list.img.map((img) => (
																	<ModalImage  small={img} large={img} hideDownload="true" />
																))}
																
																
															</div>
															{(() => {
																if (list.file.length > 0 ) {
																return (
																		<div>
																		{/*
																			<div style={{overflow:'scroll',height:470,border:'2px solid #0b85d4'}}>
																			
																			
																			{list.file.map((img) => (
																				<Test title={img}/>
																			))}
																			</div>
																		*/}	
																		</div>  
																		  )
																}
																})()}
															{(() => {
															if (list.video.length > 0 ) {
															return (
																	<span >
																		{list.video.map((img) => (
																			 <audio controls controlsList="nodownload">
																			  <source src={img} type="audio/ogg" />
																			  <source src={img} type="audio/mpeg" />
																			</audio>
																		))}
																	</span>  
																	  )
															}
															})()}
														</div>  
														  )
												}
												})()}
											 
											</>	  
											))} 
											</>	
											</Modal>
										
										</div>	
										))}
										
										
										</div>
									</div>

									
									))}
								 </div>
					</div>
				</div>	
				
		<div class="mobile-view">
			<div class="children bg-blue communication flow-root">
                     		<Drawer
									  title="Filter"
									  width="100%"
									  onClose={this.onCloseClass}
									  visible={this.state.mobile_class}
									  bodyStyle={{ paddingBottom: 80 }}
									  className="select-child"
									  
									>
										<div class="col m12 s12 view-Profile no-padd row">
											<div class="col m2 s12 mt-10">
												<label>From Date</label>
												<DatePicker onChange={this.onChangefrom_} />
											</div>
											<div class="col m2 s12 mt-10">
												<label>To Date</label>
												<DatePicker onChange={this.onChangeto_} />
											</div>
											<div class="col m2 s12 mt-10 mb-10">
												<label>Select Program</label>
												<Select name="program" value={this.state.program}  onChange={this.change_program}>
													<Select.Option value="">Select</Select.Option>
													{this.state.program_list.map((list) => ( 
														<Select.Option value={list.id}>{list.name}</Select.Option>
													))}
												</Select>
											</div>
											<div class="col m2 s12 mt-10 mb-10">
												<label >Activity				</label>
												<Select name="activity" value={this.state.activity}  onChange={this.change_activity}>
													
													<Select.Option value="dairy">Diary</Select.Option>
													<Select.Option value="food">Food</Select.Option>
													<Select.Option value="health">Health</Select.Option>
													<Select.Option value="observation">Observation</Select.Option>
													<Select.Option value="play_learn">Play & Learn</Select.Option>
													<Select.Option value="potty">Potty</Select.Option>
													<Select.Option value="star">Star</Select.Option>
													<Select.Option value="sleep">Sleep</Select.Option>
												</Select>
											</div>
											<div class="col m2 s12 mt-10">
												<label>Staff</label>
												<Select>
													{this.state.staff_list.map((list) => ( 
														<Select.Option value={list.id}>{list.first_name}</Select.Option>
													))}
												</Select>
											</div>
										</div>
										<div className="fix-foter">
										 
										  <Button onClick={this.search} type="primary">
											Done
										  </Button>
										</div>
								</Drawer>
								<div class="notice-left">
									<a onClick={this.showDrawerClass} class="btn-floating btn-large gradient-45deg-light-blue-cyan"><i class="material-icons">filter_alt</i></a>
								</div>
								
								
								
								
								 <div class="col m12 s12 no-padd">
								 
								<p id="error_1" class="center mt-20">Please Wait While Loading !!</p>
								
								 {this.state.school_list.map((list) => (
								 
									
									
									<div class="col s12 m12 no-padd">
										<div class="row">
										{list.daily_report.map((row) => (
										<div>
										
										
										<div class="col m12 s12 center image">
											<div class="dailry-report  pt-10 pb-20 "><b class="bg-color-1">{row.added_date}</b></div>
										</div>
										{row.list.map((sleep) => (
										<div>		
										<div class="col m12 s12 no-padd dialy-repot-div">
											<div class="col m1 s2 title mt-10 center no-padd">
												<img src={sleep.image} class="atd-img" />
											</div>
											<div class="col m10 s10 title mt-10  no-padd no-padd">
												<div class="col m12 s12 cursor no-padd" onClick={this.showDrawer.bind(this,sleep.id,sleep.case,sleep.title,sleep.student_id)}>
														{(()=>{																if (sleep.profile_pic != '') {
																return (
																	<img src={sleep.profile_pic} class="history-img" /> 
																)
														}else{
																return (
																	<img src={person} class="history-img" /> 
																)
														}
													})()}
													
													
													<b>{sleep.first_name} {sleep.last_name}</b>
												</div>
												<div class="col m12 s12 no-padd">
													<div class="col m8 s12 no-padd">
														<div class="notes-desc "><b>{sleep.title}</b> </div>
														<div class="notes-desc ">{sleep.details}</div>
													</div>	
													<div class="col m4 s12 no-padd">
													<div class="notes-desc right">{sleep.added_time}</div>
													</div>
												</div>	
											</div>
											
										</div>	
										
										</div>
										))}
										
											<Drawer
											  title={this.state.title}
											  width="100%"
											  onClose={this.onClose}
											  visible={this.state.mobile_child}
											  bodyStyle={{ paddingBottom: 80 }}
											  className="select-child"
											>
											
												<div class="children bg-blue attendance mt-10">
													<>
											{this.state.single_history.map((list)=>(
											<>
											  <p>Program Name : {list.program_name}</p>
											  <p>{(()=>{																if (list.profile_pic != '') {
															return (
																<img src={list.profile_pic} class="history-img" /> 
															)
													}else{
															return (
																<img src={person} class="history-img" /> 
															)
													}
												})()} <b>{list.first_name} {list.last_name} </b> <span class="right mt-10 modal-time">{list.date}</span></p>
											  
											    {(() => {
												if(list.case == 'sleep') {
												return (
														<div>
														  <p>Start Time : {list.start_time}</p>
														  <p>End Time : {list.end_time}</p>
														</div>  
														)
												}
												})()}
												
												{(() => {
												if(list.case == 'play_learn') {
												return (
													<div>
													  <p>Activity Type : {list.activity_type}</p>
													  <p>Start Time : {list.start_time}</p>
													  <p>End Time : {list.end_time}</p>
													  <p>Item Name : {list.item_name}</p>
													 </div> 
													  )
												}
												})()}

												
												
												{(() => {
												if(list.case == 'potty') {
												return (
														<div>
														  <p>Type : {list.type}</p>
														  <p>Sub Type : {list.sub_type}</p>
														</div>
														)
												}
												})()}
											  
												
												
												{(() => {
												if(list.case == 'health') {
												return (
														<div>
														  <p>Health Type : {list.health_type}</p>
														  <p>Weight : {list.weight}</p>
														  <p>Height : {list.height}</p>
														  <p>Curcumtance : {list.head}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'observation' ) {
												return (
														<div>
														  <p>Observation Type : {list.observation_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'dairy' ) {
												return (
														<div>
														  <p>Communication Type : {list.communication_type}</p>
														  <p>Like : {list.like_type}</p>
														  <p>Comment : {list.comment_type}</p>
														  <p>Notification : {list.notification_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'food' ) {
												return (
														<div>
														  <p>Meal Type : {list.meal_type}</p>
														  <p>Quantity : {list.quantity}</p>
														  <p>Item Name : {list.food_item_name}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'star' ) {
												return (
														<div>
														  <p>Star Type : {list.star_type}</p>
														</div>  
														  )
												}
												})()}
												
												{(() => {
												if(list.case == 'gallery' ) {
												return (
															<div class="history-modal-img">
															  <p>Album Name : {list.album_name}</p>
															  {list.album.map((img) => (
																<>
																	{(() => {
																		if (img.type == 'image' ) {
																		return (
																				<ModalImage  small={img.url} large={img.url} hideDownload="true" /> 
																				)
																		}else if(img.type == 'video'){
																			return (
																				<video style={{'margin-top' : '10px'}} width="320" height="240" controls>
																				  <source src={img.url} type="video/mp4" />
																				  <source src={img.url} type="video/ogg" />
																				</video> 
																				  )
																		}
																	})()}
																</>	
																))}
															</div>  
														  )
												}
												})()}
														 
														 
												
											  <p>Details : {list.details}</p>
												 {(() => {
													if (list.attach == '1' ) {
													return (
															<div>
																<span>Attachment :</span>
																<div class="attachment">
																   {list.img.map((img) => (
																		<ModalImage  small={img} large={img} hideDownload="true" />
																	))}
																	
																	
																</div>
																{(() => {
																	if (list.file.length > 0 ) {
																	return (
																			<div>
																			{/*
																				<div style={{overflow:'scroll',height:470,border:'2px solid #0b85d4'}}>
																				
																				
																				{list.file.map((img) => (
																					<Test title={img}/>
																				))}
																				</div>
																			*/}	
																			</div>  
																			  )
																	}
																	})()}
																{(() => {
																if (list.video.length > 0 ) {
																return (
																		<span >
																			{list.video.map((img) => (
																				 <audio controls controlsList="nodownload">
																				  <source src={img} type="audio/ogg" />
																				  <source src={img} type="audio/mpeg" />
																				</audio>
																			))}
																		</span>  
																		  )
																}
																})()}
															</div>  
															  )
													}
													})()}
											</>	  
											))} 
											</>	 
													   
													
												</div>
											
												<div className="fix-foter">
													 
													 <Button onClick={this.handleOk} type="primary">
														Done
													 </Button>
												</div>
											  
											</Drawer>
										
										</div>	
										))}
										
										
										</div>
									</div>

									
									))}
								 </div>
					</div>
		
		
		</div>	
											
					
					
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
